// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"04d89de3","38":"b9392d7d","220":"eadcc330","305":"1b436a30","442":"4dc84171","447":"d86bb363","525":"f66907e2","557":"80a1cea5","614":"5a949b37","640":"25a3ecc5","910":"1e85caaf","950":"fc77df69","953":"1cbdb4db","966":"fba953b4","972":"4b38a738"}[chunkId] + ".chunk.js";
};